var _path, _g, _g2, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgScrumlrLp10(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 160,
    height: 160,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0057ff",
    d: "M0 0h160v160H0z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#5e00ff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.139 81.359c0-18.108 14.679-32.787 32.787-32.787s32.787 14.679 32.787 32.787z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.713 81.36c0 18.108-14.679 32.787-32.787 32.787S47.139 99.468 47.139 81.36z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M112.713 81.36H79.926V48.573c18.108 0 32.787 14.679 32.787 32.787z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.139 81.359h32.787v32.787c-18.108 0-32.787-14.679-32.787-32.787z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M127.114 81.361h32.787v32.787c-18.108 0-32.787-14.679-32.787-32.787zm-94.327 0H0V48.574c18.108 0 32.787 14.679 32.787 32.787z",
    fill: "#E20360"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M127.114 81.359h32.787V48.573c-18.107 0-32.786 14.679-32.787 32.786zm-94.327.004H0v32.786c18.107 0 32.786-14.679 32.787-32.786z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScrumlrLp10);
export default __webpack_public_path__ + "static/media/scrumlr-lp-10.c30826ae32f6fcf98fe4647d5db8a45a.svg";
export { ForwardRef as ReactComponent };